import React from "react";
import "../styles/AddFunds.css";

const AddFundsSection = () => {
  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/918000047833?text=${encodedMessage}`;
  return (
    <>
      <section className="add-funds-section">
        <h1 className="funds-title">How to Place a Bet on <span className="highlight">Mahadev Book?</span></h1>
        <p className="funds-description">
          Betting on Mahadev Book is very fast & easy. You can place a bet on more than 1000+ sports and over 150 live casino games without registering on the betting site. You also just need to check the available live games on the website interface. Choose the games you want to bet on, select the preferred betting options, and place the bets in no time.
        </p>
        <p className="funds-description">
          If you want to place bets for specific matches, you can go to the Fancy Bet option when you select your preferred match. That is where you will be able to carefully place your bet for your favorite team.
        </p>
        <ol className="funds-steps"> <p>Pick Deposit if you wish to add money to your account.</p>
          <li>When funds are being deposited, agree to the terms of use which might include platform fees which are valid.</li>
          <li>
            Place bets anywhere and at any time with Mahadev Book in a hassle free manner!
          </li>
        </ol>

        <a
          href={ContactLink}
          target="_blank"
          rel="noopener noreferrer"
          className="contactus-button"
        >
          Contact Us @ 8888568888
        </a>
      </section>
      <section className="whatsapp-section">
        <h1 className="whatsapp-title"><span className="highlight">Mahadev Book</span> Book WhatsApp Number</h1>
        <p className="whatsapp-description">
          Feel free to contact us.
        </p>
        <a
          href={ContactLink}
          target="_blank"
          rel="noopener noreferrer"
          className="contactus-button"
        >
          Contact Us @ 8888568888
        </a>
      </section>

      <section className="placebet-section">
        <h1 className="placebet-title">How to place bet on <span className="highlight">Mahadev Book</span> Book?</h1>
        <p className="placebet-description">
        Placing Bets on <span>Mahadev Book Book</span>: Bet on 1000+ Games and 150+ Live Casino Games Without Registration. The live games are conveniently showcased on the platform's dashboard. Simply choose a game, make your selection, and proceed to place your wager. For specific match-related bets, head to the Fancy Bet section after selecting the match, and confidently place your & wager on the team of your choice.
        </p>
        <p className="placebet-description">
          Click on the Button Below and Chat with our Sales team and get your credentials.
        </p>
        <a
          href={ContactLink}
          target="_blank"
          rel="noopener noreferrer"
          className="contactus-button"
        >
          Contact Us @ 8888568888
        </a>
      </section>

      <section className="choosebetween-section">
        <h1 className="choosebetween-title">At <span className="highlight">Mahadev Book</span> Choose Between Multiple <span className="highlight">Sports Games</span> and <span className="highlight">Live Casinos</span> to Bet on</h1>
        <p className="choosebetween-description">
        The Mahadev Book Cricket ID platform boasts an extensive collection of sports games, covering cricket, basketball, football, tennis, soccer, and more. You have the flexibility to place bets on any sports game or live match of your choice. Beyond sports, the platform also features live casinos, providing an opportunity to test your luck and potentially win big.
        </p>
        <a
          href={ContactLink}
          target="_blank"
          rel="noopener noreferrer"
          className="contactus-button"
        >
          Contact Us @ 8888568888
        </a>
      </section>

      <section className="getintouch-section">
        <h1 className="getintouch-title">How to <span className="highlight">Get in Touch</span> with <span className="highlight">Mahadev Book</span> Book?</h1>
        <p className="getintouch-description">
          The contact information is available on the webpage. You can also reach us through any of the WhatsApp numbers provided below.
        </p>
        <a
          href={ContactLink}
          target="_blank"
          rel="noopener noreferrer"
          className="contactus-button"
        >
          Contact Us @ 8888568888
        </a>
      </section>

      <section className="withdrawcash-section">
      <div className="withdraw-container">
      <h2 className="withdraw-title">How to Withdraw Cash from Mahadev Book?</h2>
      <p className="withdraw-subtitle">
        Making a cash withdrawal from the Mahadev Book is devoid of any challenges. 
        Here is how to safely withdraw your earnings from our online mahadev book:
      </p>

      <div className="withdraw-grid">
        <div className="withdraw-box">
          <h3>Make a Withdrawal Request</h3>
          <p>Use the contact details uploaded on the site to place a valid withdrawal request.</p>
        </div>
        <div className="withdraw-box">
          <h3>Settle All Pending Bets</h3>
          <p>Before requesting withdrawal, please make sure that all the open bets are resolved.</p>
        </div>
        <div className="withdraw-box">
          <h3>Approval Process</h3>
          <p>Your request will be processed by submitting this request to us and all the details need to be verified.</p>
        </div>
        <div className="withdraw-box">
          <h3>Withdrawal Costs</h3>
          <p>In some circumstances, a minimal held withdrawal fee can also be applied.</p>
        </div>
        <div className="withdraw-box">
          <h3>Deposit to Your Bank Account</h3>
          <p>
            Regardless, once everything is approved, the funds shall be credited to the Bank account that you had registered to.
          </p>
        </div>
      </div>

      <div className="withdraw-subtitle">
        <p>
          Here at <strong>Mahadev Book</strong> too we know the importance of responsible gambling.
          Our platform allows our clients to deposit or withdraw money for <strong>24 hours a day </strong> 
          thereby giving you the flexibility to play and cash out at any preferred time. It should be noted 
          that this is a gambling activity and it can be very addictive. Bet wisely, invest your money wisely 
          and enjoy the game but with due respect to the risks involved.
        </p>
        <p>
          We validate the details before we go any further with your request, and after confirmation, the 
          money will be processed and transferred to your specific bank account.
        </p>
      </div>
      <a
          href={ContactLink}
          target="_blank"
          rel="noopener noreferrer"
          className="contactus-button"
        >
          Contact Us @ 8888568888
        </a>
    </div>
      </section>
    </>
  );
};

export default AddFundsSection;
